export default "__VITE_PUBLIC_ASSET__1a4b4240__"